import React from "react";
import isDevEnvironment from "shared/@utils/isDevEnvironment";
import isQaModeEnabled from "shared/@utils/isQaModeEnabled";
import styles from "./index.module.css";

/**
 * Corner badge shown when QA mode is unlocked on a NON-dev environment, so a
 * tester always knows they're seeing unreleased sections that normal users
 * can't. Hidden on dev (everything is visible there anyway) and whenever QA
 * mode is off.
 */
export default function QaModeBadge() {
  if (isDevEnvironment() || !isQaModeEnabled()) return null;
  return (
    <div
      className={styles.badge}
      role="status"
      title="QA mode is unlocked in this browser — unreleased sections are visible. Append ?qa=off to any URL to turn it off."
    >
      <span className={styles.dot} aria-hidden="true" />
      QA MODE — unreleased sections visible
    </div>
  );
}
